import {ApiBuilder} from "..";
import {User, Response} from "../../model";

const deleteUserGroup = (builder: ApiBuilder) =>
  builder.mutation<Response<User>, {userId: string; groupId: string}>({
    query: body => ({
      url: "/api/group/delete-user-group",
      method: "DELETE",
      body,
    }),
    invalidatesTags: [
      {type: "group" as never, id: "SEARCH"},
      {type: "user" as never, id: "SEARCH"},
    ],
  });

const addUserGroup = (builder: ApiBuilder) =>
  builder.mutation<Response<User>, {userId: string; groupId: string}>({
    query: body => ({
      url: "/api/group/add-user-group",
      method: "PATCH",
      body,
    }),
    invalidatesTags: [
      {type: "group" as never, id: "SEARCH"},
      {type: "user" as never, id: "SEARCH"},
    ],
  });

export {addUserGroup, deleteUserGroup};
